import { Component, EventEmitter, Injector, OnInit, Output } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ActivatedRoute } from '@angular/router';
import { SecretaryInterface } from 'app/core/interfaces/secretary';
import { BaseComponent } from 'app/modules/shared/components/base.component';
import { skip } from 'rxjs';


@Component({
  selector: 'page-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent extends BaseComponent implements OnInit {

  public titles = ['Meus dados', 'Endereço', 'Horários', 'Dados profissionais'];

  activeTabIndex = 0;

  public selectedTabIndex = 0
  public secretary !: SecretaryInterface

  alerts: string[] = [];

  constructor(private injector: Injector, private route: ActivatedRoute) {
    super(injector)

  }

  ngOnInit(): void {
    this.listenToTabQueryParam()
  }

  ngOnChanges() { this.evaluateAlerts(); }

  setSecretary(secratary: SecretaryInterface){
    this.secretary = secratary
    
    this.evaluateAlerts()
    
  }

  evaluateAlerts() {
    this.alerts = [];

    if (this.checkIfIsFirstAccess()) {
      this.alerts = [
        "📌 Complete seu <strong>perfil</strong>",
        // "📍 Defina suas <strong>Qualificações</strong>",
        // "⏰ Defina sua <strong>Localização</strong>",
      ];

      this.messageWarning = `
        <h4>Olá, seja bem-vindo(a). Para uma melhor experiência:</h4>
        <ul>
          ${this.alerts.map(a => `<li>${a}</li>`).join('')}
        </ul>
      `;

      return
     
    }
    // if (
    //   this.objectIsEmpty(this.secretary?.qualifications) &&
    //   this.objectIsEmpty(this.secretary?.communication)
    // ) {
    //   this.alerts.push("📍 Preencha suas <strong>Qualificações</strong>");
    // }

    // if (this.objectIsEmpty(this.secretary?.address)) {
    //   this.alerts.push("⏰ Defina sua <strong>Localidade</strong>");
    // }

    // if (this.alerts.length > 0) {
    //   this.messageWarning = `
    //     <h4>Olá, seja bem-vindo(a). Para uma melhor experiência:</h4>
    //     <ul>
    //       ${this.alerts.map(a => `<li>${a}</li>`).join('')}
    //     </ul>
    //   `;
    //   this.showWarningMessage = true
    // } else {
    //   this.showWarningMessage = false
    //   this.messageWarning = '';
    // }
  }

  private resolveInitialTabIndex(): number {
    const tabName = localStorage.getItem('tabAfterReload') ?? 'perfil';
    localStorage.removeItem('tabAfterReload');

    return this.getTabIndexByName(tabName);
  }

  private listenToTabQueryParam(): void {
    this.route.queryParams
      .pipe(skip(1))
      .subscribe((params) => {
        const tabName = params['tab'];

        if (tabName) {
          const index = this.getTabIndexByName(tabName);

          if (this.selectedTabIndex !== index) {
            this.setTabIfAllowed(index);
          }
        }

      });
  }

  private setTabIfAllowed(index: number): void {
    if (this.isTabAllowed(index)) {
      this.selectedTabIndex = index;
    }
  }

  private isTabAllowed(index: number): boolean {
    return !(this.checkIfIsFirstAccess() && index > 0);
  }

  onTabChange(event: MatTabChangeEvent): void {
    const tabName = this.getTabNameByIndex(event.index);

    this.router.navigate([], {
      queryParams: { tab: tabName },
      queryParamsHandling: 'merge'
    });
  }

  getTabIndexByName(tabName: string): number {
    switch (tabName) {
      case 'perfil':
        return 0;
      case 'localizacao':
        return 1;
      case 'qualificacao':
        return 2;
      default:
        return 0;
    }
  }

  getTabNameByIndex(index: number): string {
    switch (index) {
      case 0:
        return 'perfil';
      case 1:
        return 'localizacao'
      case 2:
        return 'qualificacao';
      default:
        return 'perfil';
    }
  }

  checkIfIsFirstAccess() {
    const isFirstAccess = localStorage.getItem('isFirstAccess') === 'true';

    if (isFirstAccess) {
      this.showWarningMessage = true
    }

    return isFirstAccess
  }


  objectIsEmpty(obj?: any): boolean {

      if (obj == null) return true;

      if (Array.isArray(obj)) {
        return obj.length === 0;
      }

      if (typeof obj === 'object') {
        const values = Object.values(obj);
        return values.every(
          v =>
            v === null ||
            v === undefined ||
            (typeof v === 'string' && v.trim() === '')
        );
      }

      return false;
  }


}

